
import { useEffect, useState } from 'react'
import { brandSettings } from '../../../../app/modules/settings/BrandSettings'
import { KTIcon } from '../../../helpers'
import { APP_VERSION } from '../../../../app/Constants'
import { fetchBackendVersion } from '../../../../app/api'

const SidebarFooter = () => {
  const [backendVersion, setBackendVersion] = useState<string>('')
  const [isMinimized, setIsMinimized] = useState(
    () => document.body.getAttribute('data-kt-app-sidebar-minimize') === 'on'
  )

  useEffect(() => {
    fetchBackendVersion().then(setBackendVersion)
  }, [])

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsMinimized(document.body.getAttribute('data-kt-app-sidebar-minimize') === 'on')
    })
    observer.observe(document.body, { attributes: true, attributeFilter: ['data-kt-app-sidebar-minimize'] })
    return () => observer.disconnect()
  }, [])

  return (
    <div className='app-sidebar-footer flex-column-auto pt-2 pb-6 px-6' id='kt_app_sidebar_footer'>
      {!isMinimized && (
        <div className='d-flex justify-content-between text-secondary px-2 mb-2' style={{ fontSize: '0.7rem', opacity: 0.5 }}>
          <span>FE v{APP_VERSION}</span>
          {backendVersion && <span>BE v{backendVersion}</span>}
        </div>
      )}
      {brandSettings.showHelp !== false &&
      <a
      href={import.meta.env.VITE_APP_PREVIEW_DOCS_URL}
      target='_blank'
      className='btn btn-flex flex-center btn-custom btn-primary overflow-hidden text-nowrap px-0 h-40px w-100'
      data-bs-toggle='tooltip'
      data-bs-trigger='hover'
      data-bs-dismiss-='click'
      title={'myBooks AI Help Documents!'.toTranslatedDisplay()}
    >
      <span className='btn-label'>{'Help & Support'.toTranslatedDisplay()}</span>
      <KTIcon iconName='document' className='btn-icon fs-2 m-0' />
    </a>
      }

    </div>
  )
}

export {SidebarFooter}
